import { useNode } from "@craftjs/core";
import React, { useState } from "react";
import { motion } from "framer-motion";

import {
  CenterAlignActiveIcon,
  CenterAlignIcon,
  LeftALignActiveIcon,
  LeftALignIcon,
  RightAlignActiveIcon,
  RightAlignIcon,
  TextActiveIcon,
  PencilActiveIcon,
  PaintIcon,
  SettingsIcon,
} from "../../../assets/ui-icons";
import { isUpdatedFromDefault } from "../../utils";

import {
  ColorInput,
  MarginInput,
  OptionsInput,
  PaddingInput,
  Panel,
  RangeInput,
  SpacerInput,
  Tabs,
} from "./../../ui-kit";
import IconInput from "../../ui-kit/icon";
import RightBar from "../../ui-kit/rightbar";
import { IconPack } from "../../../assets/icon-pack";
import { INPUT_LIMITS } from "../../input-limits";

export const CMSIconSettings = () => {
  const {
    actions: { setProp },
    props,
    id,
  } = useNode((node) => ({
    text: node.data.props.text,
    props: node.data.props,
  }));

  const {
    icon,
    customIcon,
    align,
    hasCustomIcon,
    size = 24,
    color,
    padding,
    margin,
  } = props;

  const General = () => {
    return (
      <>
        <SpacerInput>
          <IconInput
            resetValue={undefined}
            activeIcon={icon}
            setActiveIcon={(val) => {
              setProp((props) => {
                props.icon = val;
              });
            }}
            supportCustom
            hasCustomIcon={hasCustomIcon}
            setHasCustomIcon={(val) => {
              setProp((props) => {
                props.hasCustomIcon = val;
              });
            }}
            customIcon={customIcon}
            setCustomIcon={(val) => {
              setProp((props) => {
                props.customIcon = val;
              });
            }}
          />
          <RangeInput
            resetValue={24}
            label="Size"
            value={size}
            onChange={(val) => {
              setProp((props) => {
                props.size = val + "px";
              });
            }}
            min={INPUT_LIMITS["icon-size"].min}
            max={INPUT_LIMITS["icon-size"].max}
          />
          <OptionsInput
            label={"Alignment"}
            value={align}
            onChange={(val) => {
              setProp((props) => {
                props.align = val;
              });
            }}
            options={[
              {
                label: "Left",
                value: "left",
                icon: <LeftALignIcon width={"20px"} />,
                active: <LeftALignActiveIcon width={"20px"} />,
              },
              {
                label: "Center",
                value: "center",
                icon: <CenterAlignIcon width={"20px"} />,
                active: <CenterAlignActiveIcon width={"20px"} />,
              },
              {
                label: "Right",
                value: "right",
                icon: <RightAlignIcon width={"20px"} />,
                active: <RightAlignActiveIcon width={"20px"} />,
              },
            ]}
          />
        </SpacerInput>
      </>
    );
  };

  const Styles = () => {
    return (
      <Panel label={"Colors"} isOpen={true}>
        <SpacerInput>
          <ColorInput
            value={color}
            onChange={(val) => {
              setProp((props) => {
                props.color = val;
              });
            }}
            label={"Color"}
            useTextColorPalette={true}
          />
        </SpacerInput>
      </Panel>
    );
  };
  const Advance = () => {
    return (
      <SpacerInput>
        <PaddingInput
          value={padding}
          onChange={(val) => {
            setProp((props) => {
              props.padding = val;
            });
          }}
        />
        <MarginInput
          value={margin}
          onChange={(val) => {
            setProp((props) => {
              props.margin = val;
            });
          }}
        />
      </SpacerInput>
    );
  };

  const tabs = [
    {
      label: "General",
      key: "general",
      icon: IconPack.GeneralSettings,
      children: General(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Style",
      key: "style",
      icon: IconPack.Style,
      children: Styles(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Advanced",
      key: "advanced",
      icon: IconPack.Settings,
      children: Advance(),
      isUpdated: isUpdatedFromDefault([]),
    },
  ];

  return (
    <div className="h-full w-[330px] post-edit-right-sidebar p-2 overflow-auto dashboard-ui-scrollbar ">
      <div className="w-full rounded-t-[21px] bg-white">
        <div className="p-5 flex justify-between">
          <RightBar title={"Icon"} icon={<TextActiveIcon />} />
        </div>

        <Tabs id={`block-cms-settings-tab-${id}`} items={tabs} />

        <div className="py-2 bg-ui-light-white"></div>
      </div>
    </div>
  );
};
